<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'bulma/css/bulma.css'
import 'font-awesome/css/font-awesome.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
export default {
  name: 'app'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?3f28786e